import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class MinimalistPopUp extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        actionButtonText: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        children: PropTypes.any,

        onClose: PropTypes.func.isRequired
    };

    constructor( props, context ) {
        super( props, context );

        this.state = {};

        this.onClose = this.onClose.bind( this );
    }

    onClose( action ) {
        this.props.onClose( action === 'accept' );
    }

    render() {
        const { title, isActive, actionButtonText, children } = this.props;
        return (
            <div className={ classNames( 'minimalist-popup', { 'is-visible': isActive } ) }>
                <div className="minimalist-popup__frame" onClick={ this.close } title="Close Modal"> </div>

                <div className="minimalist-popup__content">
                    <div className="minimalist-popup__header">
                        <h3 className="minimalist-popup__title">{ title }</h3>
                    </div>
                    <div className="minimalist-popup__body">
                        { children }
                    </div>
                    <div className="minimalist-popup__buttons">
                        <button type="button" className="button button--minimalist" onClick={ this.onClose }>
                            Cancel
                        </button>

                        <button type="button" className="button button--minimalist"
                                onClick={ this.onClose.bind( this, 'accept' ) }>
                            { actionButtonText }
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default MinimalistPopUp;
